import { render, staticRenderFns } from "./SithMesStoolPrHistoryPriceList.vue?vue&type=template&id=9c2a9478&"
import script from "./SithMesStoolPrHistoryPriceList.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolPrHistoryPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports